import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  ecommerceDescription: {
    id: "funding-application: connect ecommerce description",
    defaultMessage:
      "Your payment platform data is used alongside the data from your eCommerce platform to give us important information about your revenue and order patterns, and insights into how your company is likely to grow. This helps us determine how much funding we can offer.",
  },
  connectTitle: {
    id: "funding-application: connect title",
    description: "Title for connect pages",
    defaultMessage: "Connect {connectorName}",
  },
});
